import { Alert, AlertTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const HowToUseBankConnection = () => {
  const { t } = useTranslation('bank-connection');
  return (
    <Alert severity={'info'} sx={{ p: 4, backgroundColor: 'background.paper' }} variant={'outlined'}>
      <AlertTitle>{t('howToUse.title')}</AlertTitle>
      <Typography variant={'subtitle1'} whiteSpace={'break-spaces'}>
        {t('howToUse.description')}
      </Typography>
    </Alert>
  );
};
